/** PostHog's built-in CSS class: excluded from session replay and autocapture. */
export const POSTHOG_DO_NOT_RECORD_CLASS = "ph-no-capture"

/** Apply to roots that must never be recorded when cheap to tag locally. */
export const SENSITIVE_CAPTURE_ROOT_SELECTORS = [
  "[data-sensitive-preview]",
  "[data-certificate-preview]",
  "[data-free-text-root]",
  ".document-preview-root",
  ".certificate-preview-root",
] as const

export const tagSensitiveCaptureRoots = (): void => {
  if (typeof document === "undefined") {
    return
  }

  for (const selector of SENSITIVE_CAPTURE_ROOT_SELECTORS) {
    for (const element of document.querySelectorAll(selector)) {
      element.classList.add(POSTHOG_DO_NOT_RECORD_CLASS)
    }
  }
}
